/* node_modules/@roxi/routify/runtime/Router.svelte generated by Svelte v3.55.1 */
import {
	SvelteComponent,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	group_outros,
	init as init_1,
	insert,
	mount_component,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { setContext, onDestroy } from 'svelte';
import Route from './Route.svelte';
import Prefetcher from './Prefetcher.svelte';
import { init } from './navigator.js';
import { route, routes as routesStore } from './store.js';
import defaultConfig from '../runtime.config';

function create_if_block(ctx) {
	let route_1;
	let current;
	route_1 = new Route({ props: { nodes: /*nodes*/ ctx[0] } });

	return {
		c() {
			create_component(route_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(route_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const route_1_changes = {};
			if (dirty & /*nodes*/ 1) route_1_changes.nodes = /*nodes*/ ctx[0];
			route_1.$set(route_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(route_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(route_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(route_1, detaching);
		}
	};
}

function create_fragment(ctx) {
	let t;
	let prefetcher;
	let current;
	let if_block = /*nodes*/ ctx[0] && /*$route*/ ctx[1] !== null && create_if_block(ctx);
	prefetcher = new Prefetcher({});

	return {
		c() {
			if (if_block) if_block.c();
			t = space();
			create_component(prefetcher.$$.fragment);
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, t, anchor);
			mount_component(prefetcher, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*nodes*/ ctx[0] && /*$route*/ ctx[1] !== null) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*nodes, $route*/ 3) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(t.parentNode, t);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(prefetcher.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(prefetcher.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t);
			destroy_component(prefetcher, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $route;
	component_subscribe($$self, route, $$value => $$invalidate(1, $route = $$value));
	let { routes } = $$props;
	let { config = {} } = $$props;
	let nodes;
	let navigator;
	window.routify = window.routify || {};
	window.routify.inBrowser = !window.navigator.userAgent.match('jsdom');
	Object.assign(defaultConfig, config);
	const updatePage = (...args) => navigator && navigator.updatePage(...args);
	setContext('routifyupdatepage', updatePage);
	const callback = res => $$invalidate(0, nodes = res);

	const cleanup = () => {
		if (!navigator) return;
		navigator.destroy();
		navigator = null;
	};

	let initTimeout = null;

	// init is async to prevent a horrible bug that completely disable reactivity
	// in the host component -- something like the component's update function is
	// called before its fragment is created, and since the component is then seen
	// as already dirty, it is never scheduled for update again, and remains dirty
	// forever... I failed to isolate the precise conditions for the bug, but the
	// faulty update is triggered by a change in the route store, and so offseting
	// store initialization by one tick gives the host component some time to
	// create its fragment. The root cause it probably a bug in Svelte with deeply
	// intertwinned store and reactivity.
	const doInit = () => {
		clearTimeout(initTimeout);

		initTimeout = setTimeout(() => {
			cleanup();
			navigator = init(routes, callback);
			routesStore.set(routes);
			navigator.updatePage();
		});
	};

	onDestroy(cleanup);

	$$self.$$set = $$props => {
		if ('routes' in $$props) $$invalidate(2, routes = $$props.routes);
		if ('config' in $$props) $$invalidate(3, config = $$props.config);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*routes*/ 4) {
			$: if (routes) doInit();
		}
	};

	return [nodes, $route, routes, config];
}

class Router extends SvelteComponent {
	constructor(options) {
		super();
		init_1(this, options, instance, create_fragment, safe_not_equal, { routes: 2, config: 3 });
	}
}

export default Router;